import { Component, Input } from '@angular/core';
import {
  KakaotalkTemplate,
  KakaotalkTemplateButtonTypeEnum,
} from 'src/app/parameters/message-templates/kakaotalk-templates/shared';

@Component({
  selector: 'app-kakaotalk-template-item',
  templateUrl: './kakaotalk-template-item.component.html',
  styleUrls: ['./kakaotalk-template-item.component.scss'],
})
export class KakaotalkTemplateItemComponent {
  @Input() template: KakaotalkTemplate;

  KakaotalkTemplateButtonTypeEnum = KakaotalkTemplateButtonTypeEnum;
}
